import KanoonInstituteListCard from './cards/KanoonInstituteListCard.vue'
import KanoonCourseApprovalCard from './cards/KanoonCourseApprovalCard.vue'
import KanoonFinanceCard from './cards/KanoonFinanceCard.vue'
import KanoonChildKanoonCard from './cards/KanoonChildKanoonCard.vue'
import KanoonCourseContent from './cards/KanoonCourseContent.vue'

const kanoonModuleSetup = (app) => {

    /**
     * Register Cards
     */
    app.component('KanoonInstituteListCard', KanoonInstituteListCard)
    app.component('KanoonCourseApprovalCard', KanoonCourseApprovalCard)
    app.component('KanoonFinanceCard', KanoonFinanceCard)
    app.component('KanoonChildKanoonCard', KanoonChildKanoonCard)

    /**
     * Register shared components used inside the cards
     */
    app.component('KanoonCourseContent', KanoonCourseContent)

}

export { kanoonModuleSetup }
